import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './services/AuthContext';
import { MessageProvider } from './components/Common/MessageContext/MessageContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/en-gb'; // Import UK locale
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import DefaultTheme from './components/Theme/DefaultTheme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={DefaultTheme}>
      <AuthProvider>  
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          <MessageProvider>
            <CssBaseline />
            <App />
          </MessageProvider>
        </LocalizationProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
